var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMeeting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 36,
    viewBox: "0 0 102 73",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 7a2 2 0 00-2-2H4a2 2 0 00-2 2v59a2 2 0 002 2h60a2 2 0 002-2V7zm6.632 18.04A2 2 0 0072 26.5v20a2 2 0 00.632 1.46l24 22.5A2 2 0 00100 69V4a2 2 0 00-3.368-1.46l-24 22.5z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}

export default SvgMeeting;